module.exports = __webpack_public_path__ + "files/55fbb3ac09b79fc554f78b4fa51d9bf4.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Math-Italic.ttf
// module id = 1190
// module chunks = 76